module.exports = __webpack_public_path__ + "img/office-1-mob.f5a3bf37.jpg";